export class CreatePostParamHelper {
    public static createPostParam(object : any) {
        var params : any[] = [];

        for( var name in object )
        {
            var value = object[ name ];
            var param = encodeURIComponent( name ) + '=' + encodeURIComponent( value );

            params.push( param );
        }

        return params.join( '&' ).replace( /%20/g, '+' );
    }
}